export default "__VITE_ASSET__Dqe59Ki8__"